import React from 'react';
import { QrScanChecklistModal } from '@/common/QrScan';

/**
 * Drum-specific scan-against-target-list modal.
 *
 * External API is unchanged — callers continue to pass `targetLabels` of
 * drum_label_number values, etc. All scanning UX, feedback, and partial-
 * confirm logic now lives in the shared QrScanChecklistModal.
 *
 * Props:
 *   visible           bool
 *   onCancel          () => void
 *   onConfirm         (labels: string[]) => void
 *   targetLabels      string[]
 *   title             string
 *   confirmButtonText string
 *   loading           bool
 *   scannerId         string  — accepted for backwards compatibility, no longer used
 */
const DrumScanModal = ({
  visible,
  onCancel,
  onConfirm,
  targetLabels = [],
  title = 'Scan Drums',
  confirmButtonText = 'Confirm',
  loading = false,
  // eslint-disable-next-line no-unused-vars
  scannerId
}) => (
  <QrScanChecklistModal
    visible={visible}
    onCancel={onCancel}
    onConfirm={onConfirm}
    targetLabels={targetLabels}
    title={title}
    confirmButtonText={confirmButtonText}
    loading={loading}
    noun={{ singular: 'drum', plural: 'drums' }}
    manualPlaceholder="Type drum label manually (e.g. D-123)"
  />
);

export default DrumScanModal;
